//
//
//
//
//
//

export default {
  name: 'App',
  mounted () {
    var _hmt = _hmt || [];
    (function () {
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?0a21caf9a803186cd9943cfb93c00e8d'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)
    })()
  }
}



// WEBPACK FOOTER //
// ./src/App.vue